import React from 'react';

let Aspect: React.FC<{ ratio: number }> = ({ children, ratio }) => {
  return (
    <div className="relative w-full" style={{ paddingBottom: `${ratio * 100}%` }}>
      <div className="absolute w-full h-full">{children}</div>
    </div>
  );
};

export { Aspect };
